import { useQuery } from "@tanstack/react-query";
import Alert from "@mui/material/Alert";
import { Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { assistantHealthQueryOptions } from "../../api/assistant";

export const AssistantServiceBanner = () => {
  const { t } = useTranslation();
  const health = useQuery(assistantHealthQueryOptions());

  if (!health.data || health.data.status === "healthy") return null;

  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }}>
      {t("Assistant.Service.Degraded")}
      {health.data.reason && (
        <Typography
          component="div"
          sx={{ mt: 0.5, fontFamily: "monospace", fontSize: theme => theme.typography.pxToRem(11) }}
        >
          {health.data.reason}
        </Typography>
      )}
    </Alert>
  );
};
